import React from 'react';
import { IonModal, IonPage } from '@ionic/react';
import './DocumentsList.scss';
import { HKPlatform } from 'core/constants';
import { hideDesktopDocumentEditModal } from 'features/shared/documents/DocumentsSlice';
import { useDocumentsList } from 'features/shared/documents/hooks/useDocumentsList';
import DesktopDocumentsView from 'features/shared/documents/components/DesktopDocumentsView';
import MobileDocumentsView from 'features/shared/documents/components/MobileDocumentsView';
import DocumentsAdd from 'features/shared/documents/DocumentsAdd';
import DocumentEdit from 'features/shared/documents/DocumentEdit';

const DocumentsList: React.FC = () => {
  const {
    // State
    type,
    search,
    setSearch,
    loading,
    documents,
    filteredDocuments,
    addModalVisible,
    editDesktopModalVisible,
    viewMode,
    platformType,
    isDesktopWidth,

    // Computed
    getDocumentTypeLabel,

    // Actions
    showAddDocumentsModal,
    closeAddDocumentsModal,
    openMobileDocument,
    openDesktopDocument,
    dispatch
  } = useDocumentsList();

  const isDesktop = platformType === HKPlatform.DESKTOP && isDesktopWidth;

  return (
    <IonPage
      className={isDesktop ? 'hk-desktop-digital-documents-list-page' : ''}
    >
      {isDesktop ? (
        <DesktopDocumentsView
          type={type!}
          search={search}
          onSearchChange={setSearch}
          documents={(documents as any[]) || []}
          filteredDocuments={filteredDocuments}
          loading={loading}
          viewMode={viewMode as any}
          documentTypeLabel={getDocumentTypeLabel()}
          onAddDocument={showAddDocumentsModal}
          onDocumentClick={openDesktopDocument}
        />
      ) : (
        <MobileDocumentsView
          type={type!}
          search={search}
          onSearchChange={setSearch}
          documents={(documents as any[]) || []}
          filteredDocuments={filteredDocuments}
          loading={loading}
          viewMode={viewMode as any}
          documentTypeLabel={getDocumentTypeLabel()}
          onAddDocument={showAddDocumentsModal}
          onDocumentClick={openMobileDocument as any}
        />
      )}

      <IonModal
        className="hk-digital-documents-add-modal"
        isOpen={addModalVisible}
        backdropDismiss={false}
        onDidDismiss={closeAddDocumentsModal}
      >
        <DocumentsAdd />
      </IonModal>

      <IonModal
        className="hk-desktop-digital-documents-edit-modal"
        isOpen={editDesktopModalVisible}
        onDidDismiss={() => dispatch(hideDesktopDocumentEditModal())}
      >
        <DocumentEdit />
      </IonModal>
    </IonPage>
  );
};

export default DocumentsList;
